<template>
  <span class="flex">
    <slot name="before" :on="isOn" />
    <span
      class="relative inline-flex items-center justify-center flex-no-shrink h-5 w-10 cursor-pointer focus:outline-none"
      @click="toggle"
      role="checkbox"
    >
      <span
        aria-hidden="true"
        :class="wrapperCss"
        class="absolute h-4 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200"
      ></span>
      <span
        aria-hidden="true"
        class="absolute left-0 inline-block h-5 w-5 border border-gray-200 rounded-full shadow transform transition-transform ease-in-out duration-200"
        :class="handleClass"
      />
    </span>
    <slot name="after" :on="isOn" />
  </span>
</template>
<script>
export default {
  name: 'SwitchInput',
  model: {
    prop: 'on',
    event: 'change',
  },
  props: {
    on: {
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    trueValue: {
      default: true,
    },
    falseValue: {
      default: false,
    },
    onBgColour: {
      default: 'bg-primary-dark',
    },
    offBgColour: {
      default: 'bg-gray-300',
    },
    onHandleColour: {
      default: 'bg-white',
    },
    offHandleColour: {
      default: 'bg-white',
    },
    emitOnLoad: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentValue: this.on,
      isDisabled: this.disabled,
    };
  },
  computed: {
    wrapperCss() {
      return [
        [this.isDisabled ? 'cursor-default' : 'cursor-pointer'],
        this.ifOn(
          'justify-end ' + this.onBgColour,
          'justify-start ' + this.offBgColour
        ),
      ];
    },
    handleClass() {
      return [
        this.ifOn(this.onHandleColour, this.offHandleColour),
        this.ifOn('translate-x-5', 'translate-x-0'),
      ];
    },
    isOn() {
      return this.currentValue === this.trueValue;
    },
  },
  mounted() {
    if (this.emitOnLoad) {
      this.notify(this.ifOn(this.trueValue, this.falseValue));
    }
  },
  methods: {
    ifOn(trueValue, falseValue) {
      return this.isOn ? trueValue : falseValue;
    },
    switch() {
      return (this.currentValue = this.ifOn(this.falseValue, this.trueValue));
    },
    toggle() {
      if (this.isDisabled) {
        return;
      }
      this.beforeNotify(() => {
        this.notify(this.switch());
      });
    },
    beforeNotify(callback) {
      callback();
    },
    notify(value) {
      this.$emit('change', value);
    },
  },
};
</script>
